





























import { Vue, Component } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { SaveAtributoUseCase } from '@/usecases'

@Component

export default class DialogoDeEdicaoDeAtributo extends Vue {
	atributo = {id:"", nome:""}
	mostra = false
	salvando = false
	saveAtributoUseCase = new SaveAtributoUseCase()

	mostrar(atributo) {
		this.mostra = true
		this.atributo = atributo
	}

	esconder() {
		this.mostra = false
	}

	salvar() {
		if (!this.atributo) return
		try {
			this.salvando = true
			const atributo = this.atributo

			const atributoSalvo = this.atributo.id
				? this.saveAtributoUseCase.update(atributo)
				: this.saveAtributoUseCase.create(atributo)

			this.$emit('confirmado', atributoSalvo)
			this.mostra = false
			AlertModule.setSuccess('Atributo salva com sucesso')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}
}
